import { render, staticRenderFns } from "./our-data.en.vue?vue&type=template&id=257d07ca&"
import script from "./our-data.en.vue?vue&type=script&lang=js&"
export * from "./our-data.en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports